<template>
  <div class="widget Anim__dropdown-wrapper">
    <div class="widget__hdr">
      <div class="widget__hdr-ttl-box" v-if="props.isFull">
        <div class="widget__hdr-icon-wrapper">
          <DropsIcon />
        </div>
        <p class="widget__hdr-ttl">Кэпитал Подписка</p>
      </div>  
      <div class="widget__days-box" :class="!props.isFull ? 'widget__days-box--between' : ''">
        <span class="widget__hdr-text">осталось</span>
        <span class="widget__days">
          {{ daysLeft }} <span class="widget__days-prefix">{{ time }}</span>
        </span>
      </div>
    </div>
    <div class="widget__content">
      <div class="widget__content-hdr">
        <StarsIcon /> В подписке
      </div>

      <template v-if="!props.isFull">
        <div class="widget__list">
          <div class="widget__content-item">
            <div class="widget__item-icon">
              <DropsIcon />
            </div>
            <span class="widget__text">Полный доступ к Drops Capital</span>
          </div>
          <a class="widget__content-item" href="https://t.me/+6mrvhmDBdG5jMjc6" target="_blank">
            <div class="widget__item-avt-box">
              <div class="widget__item-icon">
                <AvatarImage :src="PON_IMAGE" :size="18" />
              </div>
              <span class="widget__text">Кэпитал Work</span>
            </div>
            <LinkIcon class="widget__link-icon" />
          </a>
          <a class="widget__content-item" href="https://t.me/+CbJGANCaNcJjNGIy" target="_blank">
            <div class="widget__item-avt-box">
              <div class="widget__item-icon">
                <AvatarImage :src="PON_2_IMAGE" :size="18" />
              </div>
              <span class="widget__text">Кэпитал Meme</span>
            </div>
            <LinkIcon class="widget__link-icon" />
          </a>
          <a class="widget__content-item" href="https://t.me/+LsimjfsTOgg5YzFi" target="_blank">
            <div class="widget__item-avt-box">
              <div class="widget__item-icon">
                <AvatarImage :src="PON_3_IMAGE" :size="18" />
              </div>
              <span class="widget__text">Кэпитал Алертс</span>
            </div>
            <LinkIcon class="widget__link-icon" />
          </a>
          <div class="widget__content-item" v-if="!hasTelegram">
            <span class="widget__full-text">Чтобы присоединиться к чатам, привяжите телеграм аккаунт в 
              <router-link :to="{ name: PATHS_NAME.USER.SETTINGS }" class="widget__link">Настройках</router-link> 
              профиля и перейдите по ссылкам на чаты снова
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="widget__groups">
          <div class="widget__group-item">
            <p class="widget__group-ttl">
              <div class="widget__item-icon">
                <DropsIcon />
              </div>
              Полный доступ к Drops Capital
            </p>
            <BlockDropsBenefits />
          </div>
          <div class="widget__group-item">
            <p class="widget__group-ttl">
              <div class="widget__item-icon">
                <ChatIcon />
              </div>
               Кэпитал чаты
            </p>
            <div class="widget__group-content-list">
              <a class="widget__group-content-item" href="https://t.me/+6mrvhmDBdG5jMjc6" target="_blank">
                <div class="widget__item-avt-box">
                  <AvatarImage :src="PON_IMAGE" :size="20" />
                  <span class="widget__group-content-item-name">Кэпитал Work</span>
                </div>
                <LinkIcon class="widget__link-icon" />
              </a>
              <a class="widget__group-content-item" href="https://t.me/+CbJGANCaNcJjNGIy" target="_blank">
                <div class="widget__item-avt-box">
                  <AvatarImage :src="PON_2_IMAGE" :size="20" />
                  <span class="widget__group-content-item-name">Кэпитал Meme</span>
                </div>
                <LinkIcon class="widget__link-icon" />
              </a>
              <a class="widget__group-content-item" href="https://t.me/+LsimjfsTOgg5YzFi" target="_blank">
                <div class="widget__item-avt-box">
                  <AvatarImage :src="PON_3_IMAGE" :size="20" />
                  <span class="widget__group-content-item-name">Кэпитал Алертс</span>
                </div>
                <LinkIcon class="widget__link-icon" />
              </a>
            </div>
            <template v-if="!hasTelegram">
              <p class="widget__group-content-text">Чтобы присоединиться к чатам, привяжите телеграм аккаунт в 
                <router-link :to="{ name: PATHS_NAME.USER.SETTINGS }" class="widget__link">Настройках</router-link> 
                профиля и перейдите по ссылкам на чаты снова
              </p>
            </template>
          </div>
        </div>
      </template>
      <button class="widget__new-subscribe" @click="openSubscriptionWidget()" v-if="props.isFull">
        <div class="widget__drops-gradient">
          <DropsIcon />
        </div>
        Продлить Кэпитал Подписку
      </button>
      <div class="widget__new-subscribe-txt-btn-box" v-else>
        <button class="widget__new-subscribe-txt-btn" @click="openSubscriptionWidget()">
          Продлить Кэпитал Подписку
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, ref } from 'vue';
  import { Props } from './props';
  import { PATHS_NAME } from '@shared/routers/consts/pathsName';
  //-------------------------
  import StarsIcon from './icons/StarsIcon.vue';
  import LinkIcon from './icons/LinkIcon.vue';
  import DropsIcon from './icons/DropsIcon.vue';
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  import ChatIcon from './icons/ChatIcon.vue';
  import BlockDropsBenefits from '@shared/UI/Blocks/BlockDropsBenefits/BlockDropsBenefits.vue';
  //-------------------------
  const store = useStore();
  const props = defineProps(Props());
  //-------------------------
  const isOpenWorkChatGroup = ref(false);
  //-------------------------
  const PON_IMAGE = require('./icons/pon.jpg');
  const PON_2_IMAGE = require('./icons/pon2.png');
  const PON_3_IMAGE = require('./icons/pon3.png');
  const STAR_IMAGE = require('./icons/star.png');
  //-------------------------
  const declOfNum = (n, textForms) => {
    n = Math.abs(n) % 100;
    let n1 = n % 10;
    if (n > 10 && n < 20) return textForms[2];
    if (n1 > 1 && n1 < 5) return textForms[1];
    if (n1 === 1) return textForms[0];
    return textForms[2];
  }

  const hasTelegram = computed(() => store.getters['UserSystem/hasTelegramAccount']);
  
  const daysLeft = computed(() => {
    return store.state.UserSystem.user.cryptocloud_days_left || store.state.UserSystem.user.telegram_days_left || 0;
  });

  const time = computed(() => {
    const num = daysLeft.value;
    const word = declOfNum(num, ['день', 'дня', 'дней']);
    return `${word}`;
  });

  const openSubscriptionWidget = () => {
    store.dispatch('HeaderSystem/openSubscriptionWidget');
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>